export const XP_PER_LEVEL = 100;

/** «через ~N игр» до уровня: остаток XP / средний темп. Средний игрок
 *  получает ~2.5× базовых XP за вечер (база + задания, handoff §2–3). */
export function gamesToLevel(level: number, xp: number, xpPerGame: number): number {
  const remaining = (level - 1) * XP_PER_LEVEL - xp;
  const perGame = Math.max(1, xpPerGame) * 2.5;
  return Math.max(1, Math.ceil(remaining / perGame));
}

/** «N игр до уровня»: меньше ~половины игры — «½ игры» (макет BP Pass).
 *  Единый текст для шапки 6.1, маркера «ты здесь» и карточки 6.0a. */
/** Таймер сезона «23д 04ч» (макет BP Pass). */
export function seasonTimer(endsAt: string): string {
  const ms = Math.max(0, new Date(endsAt).getTime() - Date.now());
  const d = Math.floor(ms / 86400_000);
  const h = Math.floor((ms % 86400_000) / 3600_000);
  return `${d}д ${String(h).padStart(2, '0')}ч`;
}

/* «Показать один раз» (handoff 4 §2.4): первый экран, где пользователь
 * увидел новый уровень, записывает lastShownLevel; остальные — статично. */
const LSL_KEY = 'bp_last_shown_level';

export function lastShownLevel(): { level: number; xp: number } | null {
  try {
    const v = JSON.parse(localStorage.getItem(LSL_KEY) ?? 'null') as
      | { level: number; xp: number }
      | null;
    return v && typeof v.level === 'number' && typeof v.xp === 'number' ? v : null;
  } catch {
    return null;
  }
}

export function markShownLevel(level: number, xp: number): void {
  try {
    localStorage.setItem(LSL_KEY, JSON.stringify({ level, xp }));
  } catch {
    /* приватный режим — анимация просто не сработает */
  }
}

export function toNextLabel(level: number, xp: number, xpPerGame: number): string {
  const remaining = (level - 1) * XP_PER_LEVEL - xp;
  const g = remaining / (Math.max(1, xpPerGame) * 2.5);
  if (g <= 0.6) return '½ игры';
  const n = Math.max(1, Math.ceil(g));
  return `${n} ${n === 1 ? 'игра' : n < 5 ? 'игры' : 'игр'}`;
}
